import React, { FC } from "react";
import classNames from "classnames";

export interface TitleProps {
  level: number;
  noMargin?: boolean;
  className?: string;
  backgroundColor?: string;
}

export const Title: FC<TitleProps> = ({
  level,
  className,
  children,
  backgroundColor = "",
  ...props
}) => {
  const titleClassName = classNames({
    "xvia-title-h": true,
    [`xvia-title-h${level}`]: true,
    [`xvia-title--no-margin`]: true,
    [className || ""]: !!className,
  });

  switch (level) {
    case 1:
    default:
      return (
        <div className={titleClassName} style={{ backgroundColor }} {...props}>
          {children}
        </div>
      );
    case 2:
      return (
        <div className={titleClassName} style={{ backgroundColor }} {...props}>
          {children}
        </div>
      );
    case 3:
      return (
        <div className={titleClassName} style={{ backgroundColor }} {...props}>
          {children}
        </div>
      );
    case 4:
      return (
        <div className={titleClassName} style={{ backgroundColor }} {...props}>
          {children}
        </div>
      );
    case 5:
      return (
        <div className={titleClassName} style={{ backgroundColor }} {...props}>
          {children}
        </div>
      );
  }
};
